import { IApplicationState } from '@store'
import { toLabelValuePair } from '@utils'

export const selectCategoriesIsFetching = (state: IApplicationState) => state.categories.isFetching

export const selectCategories = (state: IApplicationState) => state.categories.categories

export const selectCategoriesAsLabelValue = (state: IApplicationState) =>
  toLabelValuePair(selectCategories(state), 'id', 'name')
